import React from 'react';
import { useSearchParams } from 'react-router-dom';

const ThankYouPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  // Try query param first, then sessionStorage (saved before redirect to payment)
  const campaignSlug = searchParams.get('campaign') || sessionStorage.getItem('lastCampaignSlug') || '';
  // Preserve the ambassador the donor came through, so "back to campaign" keeps
  // crediting them — otherwise a second donation from this session would lose
  // attribution (the ref was only ever in the original URL).
  const ambassadorRef = searchParams.get('ref') || sessionStorage.getItem('lastAmbassadorRef') || '';
  const campaignHref = `/campaign/${campaignSlug}${ambassadorRef ? `?ref=${encodeURIComponent(ambassadorRef)}` : ''}`;

  return (
    <div dir="rtl" className="min-h-screen flex items-center justify-center px-4" style={{ background: 'linear-gradient(135deg, #ecfdf5, #f0fdf4)' }}>
      <div className="text-center w-full max-w-md py-10 px-4">
        <div style={{ fontSize: 72, marginBottom: 16 }}>🎉</div>
        <h1 className="text-2xl md:text-4xl font-black text-green-700 mb-3">תודה רבה על התרומה!</h1>
        <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-2">
          התרומה שלך התקבלה בהצלחה.
        </p>
        <p className="text-sm text-gray-400 mb-8">
          קבלה תישלח אליך למייל בדקות הקרובות.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          {campaignSlug && (
            <a href={campaignHref}
              className="px-7 py-3.5 rounded-xl bg-green-700 text-white font-bold text-base no-underline hover:bg-green-800 transition-colors">
              ← חזרה לקמפיין
            </a>
          )}
          <a href="/"
            className="px-7 py-3.5 rounded-xl bg-white text-gray-700 font-semibold text-base no-underline border-2 border-gray-200 hover:bg-gray-50 transition-colors">
            לדף הבית
          </a>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;
